var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    _vm._l(_vm.images, function (image) {
      return _c(
        "li",
        { key: image.fileId, staticClass: "image" },
        [
          _c("fb-img", {
            staticClass: "mt-4",
            attrs: {
              fileId: image.fileId,
              mimeType: image.mimeType,
              mediaServiceId: _vm.mediaServiceId,
              size: "raw",
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }